import React from 'react'
import { TimeSlot } from '../types'
import { PIXELS_PER_15_MIN } from '../utils/timeUtils'

interface GridCellProps {
  dayOfWeek: number
  time: string
  slot: TimeSlot
  index: number
  onClick: (element: HTMLElement) => void
  disabled?: boolean
}

const GridCell: React.FC<GridCellProps> = ({ dayOfWeek, time, slot, index, onClick, disabled }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (!disabled) {
      onClick(e.currentTarget as HTMLElement)
    }
  }

  // Determine if this is an hour mark (solid line) or not (dashed line)
  // 00:15 should be dashed, only 00:00, 01:00, 02:00 etc should be solid
  const isHourMark = slot.minute === 0

  // Calculate top position based on index
  const top = index * PIXELS_PER_15_MIN // height per 15-min slot

  const style: React.CSSProperties = {
    position: 'absolute',
    width: '100%',
    height: `${PIXELS_PER_15_MIN}px`,
    top: `${top}px`,
  }

  return (
    <div
      className={`grid-cell ${isHourMark ? 'grid-cell-hour' : 'grid-cell-quarter'}`}
      style={style}
      onClick={handleClick}
    />
  )
}

export default GridCell